/**
* @prop --markdown-hyperlink-color: color of text for hyperlinks. Defaults to `--color-blue-dark`;
* @prop --markdown-hyperlink-color--hovered: color of text for hyperlinks when hovered. Defaults to `--color-blue-default`;
*/

@forward './partial-styles/pre-code';
@forward './partial-styles/headings';
@forward './partial-styles/body-text';
@forward './partial-styles/lists';
@forward './partial-styles/tables';
@forward './partial-styles/blockquotes';
@forward './partial-styles/definition-lists';
@forward './partial-styles/img';
@forward './partial-styles/kbd';
@forward './partial-styles/_adjust-for-table-cell';

*,
*::before,
*::after {
    box-sizing: border-box;

    & :where(:not(img, video, svg, canvas, iframe)) {
        min-width: 0;
        min-height: 0;
    }
}

// body-text
hr {
    border-top: 1px solid rgb(var(--contrast-700));
}

.MsoNormal {
    margin: 0;
}
